import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

// Map URL slug → value stored in listing publicData.collection
// Note: 'formal' slug maps to 'formals' in publicData (historical naming)
const SLUG_TO_COLLECTION_KEY = {
  bridal: 'bridal',
  formal: 'formals',
  casual: 'casual',
  mens: 'mens',
  kids: 'kids',
};

const resultIds = data =>
  (data || [])
    .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
    .map(l => l.id);

const fetchPayloadCreator = async ({ slug }, thunkAPI) => {
  const { extra: sdk, rejectWithValue, dispatch } = thunkAPI;
  const collectionKey = SLUG_TO_COLLECTION_KEY[slug] || slug;

  return sdk.listings
    .query({
      pub_collection: collectionKey,
      perPage: 48,
      page: 1,
      // Sold listings stay published with zero stock. Show them (marked
      // SOLD) instead of hiding them — minStock: 1 is what made them
      // vanish. currentStock is needed for the badge to know.
      minStock: 0,
      stockMode: 'match-undefined',
      include: ['images', 'currentStock'],
      'fields.listing': ['title', 'price', 'deleted', 'state', 'publicData'],
      'fields.image': [
        'variants.listing-card',
        'variants.listing-card-2x',
        'variants.scaled-medium',
      ],
      'limit.images': 1,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => rejectWithValue(storableError(e)));
};

export const fetchCollectionListings = createAsyncThunk(
  'CollectionPage/fetchCollectionListings',
  fetchPayloadCreator
);

const slice = createSlice({
  name: 'CollectionPage',
  initialState: {
    inProgress: false,
    error: null,
    currentPageResultIds: [],
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCollectionListings.pending, state => {
        state.inProgress = true;
        state.error = null;
        state.currentPageResultIds = [];
      })
      .addCase(fetchCollectionListings.fulfilled, (state, action) => {
        state.inProgress = false;
        state.currentPageResultIds = resultIds(action.payload.data.data);
      })
      .addCase(fetchCollectionListings.rejected, (state, action) => {
        state.inProgress = false;
        state.error = action.payload;
      });
  },
});

export default slice.reducer;

export const loadData = (params, search, config) => dispatch => {
  return dispatch(fetchCollectionListings({ slug: params.slug }));
};
